import { useTranslation } from 'react-i18next';

/** Matches `Header` logo breakpoints (h-11 → sm → lg → xl). */
const DEFAULT_PICTURE_SIZES = '(max-width: 639px) 160px, (max-width: 1023px) 180px, (max-width: 1279px) 220px, 280px';

const LOGO_SRCSET_AVIF =
  '/rentabahay-logo-w200.avif 200w, /rentabahay-logo-w400.avif 400w, /rentabahay-logo-w480.avif 480w';
const LOGO_SRCSET_WEBP =
  '/rentabahay-logo-w200.webp 200w, /rentabahay-logo-w400.webp 400w, /rentabahay-logo-w480.webp 480w';

interface LogoProps {
  className?: string;
  /** Passed to `sizes` on sources + img so the browser picks a srcset candidate for layout. */
  pictureSizes?: string;
}

export const Logo = ({
  className = 'h-10 w-auto',
  pictureSizes = DEFAULT_PICTURE_SIZES,
}: LogoProps) => {
  const { t } = useTranslation();
  return (
    <div className={`flex shrink-0 items-center justify-center ${className}`}>
      <picture>
        <source type="image/avif" srcSet={LOGO_SRCSET_AVIF} sizes={pictureSizes} />
        <source type="image/webp" srcSet={LOGO_SRCSET_WEBP} sizes={pictureSizes} />
        <img
          src="/rentabahay-logo-w200.webp"
          srcSet={LOGO_SRCSET_WEBP}
          sizes={pictureSizes}
          alt={t('site.name')}
          width={480}
          height={320}
          className="h-full w-auto max-w-full object-contain object-center"
          decoding="async"
        />
      </picture>
    </div>
  );
};

export default Logo;